import React, { useState } from "react";
import { Card, Grid, Divider, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Feature flags mock data
const FEATURE_FLAGS = [
  { key: "sara", label: "SARA Recommendations", category: "AI", enabled: true },
  { key: "saraInsights", label: "SARA Insights", category: "AI", enabled: true },
  { key: "gamification", label: "Gamification", category: "Engagement", enabled: false },
  { key: "aiCompanion", label: "AI Companion", category: "AI", enabled: true },
  { key: "personalization", label: "Personalization Engine", category: "AI", enabled: true },
  { key: "sia", label: "SIA Assistant", category: "AI", enabled: false },
  { key: "kalturaRE", label: "Kaltura RE Integration", category: "Integration", enabled: true },
  { key: "watchParty", label: "Watch Party", category: "Social", enabled: false },
  { key: "liveChat", label: "Live Chat", category: "Engagement", enabled: true },
];

const RATE_LIMITS = [
  { endpoint: "/api/v1/*", limit: "1,000 req/min", burst: 100 },
  { endpoint: "/api/v1/search", limit: "200 req/min", burst: 50 },
  { endpoint: "/api/v1/upload", limit: "50 req/min", burst: 10 },
  { endpoint: "/api/v1/stream", limit: "500 concurrent", burst: null },
];

const CONFIG_TEMPLATES = [
  { id: "tmpl-001", name: "OTT Standard", description: "Standard feature set for OTT platforms", plan: "Business", tenants: 3 },
  { id: "tmpl-002", name: "Minimal Starter", description: "Minimal configuration for trial tenants", plan: "Starter", tenants: 2 },
  { id: "tmpl-003", name: "Enterprise Full", description: "All features enabled for enterprise accounts", plan: "Enterprise", tenants: 2 },
];

function Configuration() {
  const [flags, setFlags] = useState(FEATURE_FLAGS);

  const toggleFlag = (key) => {
    setFlags(flags.map((f) => (f.key === key ? { ...f, enabled: !f.enabled } : f)));
  };

  const categories = [...new Set(flags.map((f) => f.category))];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} px={3}>
        {/* Page Header */}
        <MDBox mb={2.5}>
          <MDBox display="flex" alignItems="center" gap={1} mb={0.5}>
            <span style={{ color: "#5D6D7E", fontSize: 12 }}>Control Plane</span>
            <span style={{ color: "#BDC3C7" }}>›</span>
            <span style={{ color: "#1E3A5F", fontSize: 12, fontWeight: 600 }}>Configuration</span>
          </MDBox>
          <MDBox display="flex" alignItems="center" justifyContent="space-between">
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "#1E3A5F" }}>Configuration Management</h1>
            <MDButton variant="gradient" color="info" size="small">
              <Icon>save</Icon>&nbsp;Save Changes
            </MDButton>
          </MDBox>
        </MDBox>

        {/* <Grid container spacing={3}>
  
          <Grid item xs={12} lg={7}>
            <Card sx={{ border: "1px solid #E8EDF2" }}>
              <MDBox px={2.5} py={2} display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h6" fontWeight="bold" color="dark">Feature Flags</MDTypography>
                <MDTypography variant="caption" color="secondary">{flags.filter((f) => f.enabled).length}/{flags.length} enabled</MDTypography>
              </MDBox>
              <Divider sx={{ m: 0 }} />
              <MDBox px={2.5} py={1.5}>
                {categories.map((cat) => (
                  <MDBox key={cat} mb={2}>
                    <MDTypography variant="caption" fontWeight="bold" color="secondary" sx={{ textTransform: "uppercase", letterSpacing: 0.5, fontSize: 11, mb: 1, display: "block" }}>
                      {cat}
                    </MDTypography>
                    {flags.filter((f) => f.category === cat).map((flag) => (
                      <MDBox key={flag.key} display="flex" justifyContent="space-between" alignItems="center" py={1} sx={{ borderBottom: "1px solid #F4F6F9" }}>
                        <MDBox>
                          <MDTypography variant="button" fontWeight="medium" color="dark" sx={{ fontSize: 13 }}>{flag.label}</MDTypography>
                          <MDTypography variant="caption" color="secondary" display="block" sx={{ fontSize: 11 }}>{flag.key}</MDTypography>
                        </MDBox>
                        <Switch checked={flag.enabled} onChange={() => toggleFlag(flag.key)} color="success" size="small" />
                      </MDBox>
                    ))}
                  </MDBox>
                ))}
              </MDBox>
            </Card>
          </Grid>

   
          <Grid item xs={12} lg={5}>
         
            <Card sx={{ border: "1px solid #E8EDF2", mb: 3 }}>
              <MDBox px={2.5} py={2}>
                <MDTypography variant="h6" fontWeight="bold" color="dark">Rate Limits</MDTypography>
              </MDBox>
              <Divider sx={{ m: 0 }} />
              <MDBox px={2.5} py={1.5}>
                {RATE_LIMITS.map((rl, idx) => (
                  <MDBox key={idx} display="flex" justifyContent="space-between" alignItems="center" py={1} sx={{ borderBottom: idx < RATE_LIMITS.length - 1 ? "1px solid #F4F6F9" : "none" }}>
                    <MDBox>
                      <MDTypography variant="caption" fontWeight="bold" color="dark" sx={{ fontFamily: "monospace", fontSize: 12 }}>{rl.endpoint}</MDTypography>
                    </MDBox>
                    <MDBox textAlign="right">
                      <MDTypography variant="caption" fontWeight="medium" color="dark">{rl.limit}</MDTypography>
                      {rl.burst && <MDTypography variant="caption" color="secondary" display="block" sx={{ fontSize: 10 }}>Burst: {rl.burst}</MDTypography>}
                    </MDBox>
                  </MDBox>
                ))}
              </MDBox>
            </Card>

      
            <Card sx={{ border: "1px solid #E8EDF2" }}>
              <MDBox px={2.5} py={2} display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h6" fontWeight="bold" color="dark">Config Templates</MDTypography>
                <MDButton variant="text" color="info" size="small"><Icon>add</Icon>&nbsp;New</MDButton>
              </MDBox>
              <Divider sx={{ m: 0 }} />
              <MDBox px={2.5} py={1.5}>
                {CONFIG_TEMPLATES.map((tmpl) => (
                  <MDBox key={tmpl.id} py={1.5} sx={{ borderBottom: "1px solid #F4F6F9" }}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="flex-start">
                      <MDBox>
                        <MDTypography variant="button" fontWeight="bold" color="dark" sx={{ fontSize: 13 }}>{tmpl.name}</MDTypography>
                        <MDTypography variant="caption" color="secondary" display="block">{tmpl.description}</MDTypography>
                      </MDBox>
                      <span style={{ background: "#F0F3F6", color: "#5D6D7E", fontSize: 11, padding: "2px 8px", borderRadius: 6, fontWeight: 600 }}>
                        {tmpl.plan}
                      </span>
                    </MDBox>
                    <MDTypography variant="caption" color="secondary" sx={{ fontSize: 11, mt: 0.5, display: "block" }}>
                      Applied to {tmpl.tenants} tenants
                    </MDTypography>
                  </MDBox>
                ))}
              </MDBox>
            </Card>
          </Grid>
        </Grid> */}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Configuration;
